import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  type RestoreDefaultMarkerCustomizationsContainerProps,
  RestoreDefaultMarkerCustomizationsModalContainer,
} from './restoreDefaultMarkerCustomizationsModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    RestoreDefaultMarkerCustomizations: Omit<RestoreDefaultMarkerCustomizationsContainerProps, 'isOpen' | 'onClose'>;
  }
}

modalRenderer.register('RestoreDefaultMarkerCustomizations', (props) => <RestoreDefaultMarkerCustomizationsModalContainer {...props} />);
